/**
 * Одинаковые названия видов работ (задача 13295). Правило то же, что у проверки в Pimcore
 * (`WorkNameUniqueListener`): у площадки и клиента среди опубликованных название уникально,
 * регистр и лишние пробелы не различаются.
 */

export const normalizeWorkTypeName = (name?: string | null): string => String(name || '')
  .replace(/\s+/g, ' ')
  .trim()
  .toLowerCase();

export interface WorkTypeNode {
  id: string | number;
  name?: string | null;
  platform?: { id: string | number; name?: string | null } | null;
  client?: { id: string | number; legal_name?: string | null } | null;
}

export interface DuplicateNameGroup {
  name: string;
  platformId: string;
  platformName: string;
  clientId: string;
  clientName: string;
  ids: string[];
}

export const findDuplicateNameGroups = (nodes: WorkTypeNode[]): DuplicateNameGroup[] => {
  const groups = new Map<string, DuplicateNameGroup>();

  nodes.forEach((node) => {
    const name = normalizeWorkTypeName(node.name);
    if (!name) {
      return;
    }
    const platformId = node.platform?.id ? String(node.platform.id) : '';
    const clientId = node.client?.id ? String(node.client.id) : '';
    const key = `${platformId}|${clientId}|${name}`;
    const group = groups.get(key) || {
      name: String(node.name || '').trim(),
      platformId,
      platformName: node.platform?.name || '',
      clientId,
      clientName: node.client?.legal_name || '',
      ids: [],
    };
    group.ids.push(String(node.id));
    groups.set(key, group);
  });

  return [...groups.values()]
    .filter((group) => group.ids.length > 1)
    .sort((a, b) => `${a.platformName} ${a.clientName} ${a.name}`
      .localeCompare(`${b.platformName} ${b.clientName} ${b.name}`));
};
